import { render, staticRenderFns } from "./PersonalizeEmailsend.vue?vue&type=template&id=faa4f18c"
import script from "./PersonalizeEmailsend.vue?vue&type=script&lang=js"
export * from "./PersonalizeEmailsend.vue?vue&type=script&lang=js"
import style0 from "./PersonalizeEmailsend.vue?vue&type=style&index=0&id=faa4f18c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports